import { jsx as e } from "react/jsx-runtime";
import { isNil as r } from "es-toolkit/predicate";
import c from "../../utils/classNames.js";
const C = (o) => {
  const { showClear: s, selectedItem: t, onClear: n } = o, a = c(
    "clearButton",
    (!s || r(t)) && "hide pointer-events-none"
  );
  return /* @__PURE__ */ e("span", { className: a, onClick: (l) => {
    l.stopPropagation(), n();
  }, children: /* @__PURE__ */ e("span", { className: "clearButtonIcon rioglyph rioglyph-remove-sign" }) });
};
export {
  C as default
};
//# sourceMappingURL=ClearButton.js.map
